import React from "react";
import PropTypes from "prop-types";

import { Button, Title } from "rbx";
import { Paper } from "@mui/material";
import capitalizeEveryWord from "../../../../utils/capitalizeEveryWord";
import formatDate from "../../../../utils/formatDate";
import checkMobile from "../../../../utils/checkForMobile";

const FollowupListItem = ({
  followup,
  followupIndex,
  handleClick,
  handleOpenFollowupAdd,
  isCompletedSection = false,
  isUsersOwnFollowups,
  showManagerReviews,
}) => {
  const isMobile = checkMobile();
  const direction = isMobile ? "column" : "row";
  return (
    <li>
      <Paper elevation={4} style={{ padding: "1rem", marginBottom: "1rem", backgroundColor: isMobile ? "#f5f5f5" : "white" }}>
        <div
          className="review-item"
          key={followup.id}
          style={{ flexDirection: "column" }}
        >
          {isCompletedSection && followup?.updatedAt && (
            <div style={{ width: "100%" }}>
              <h3
                style={{
                  textAlign: isMobile ? "center" : "right",
                  marginBottom: "1rem",
                  color: "green",
                  display: "flex",
                  justifyContent: "right",
                }}
              >
                <b>Completed: </b>
                {`${formatDate(new Date(followup?.updatedAt))}`}
              </h3>
            </div>
          )}
          <p>
            <h3>{`${capitalizeEveryWord(followup.title)}`}</h3>
          </p>
          <p style={{ textAlign: isMobile ? "center" : "left" }}>
            <b>Description: </b>
            {`${followup?.description}`}
          </p>
          <hr />
          <div
            style={{
              display: "flex",
              flexDirection: direction,
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {!isCompletedSection && showManagerReviews && !isUsersOwnFollowups && (
              <React.Fragment>
                <Button
                  className="review-option-primary-goal"
                  style={{
                    marginBottom: "0.5rem",
                    padding: "0.5rem",
                    marginRight: "0.5rem",
                  }}
                  type="button"
                  onClick={() => handleOpenFollowupAdd(followup, "Edit")}
                >
                  <Title size={6} textColor="white">
                    Edit
                  </Title>
                </Button>
                <Button
                  className="review-option-tertiary-goal"
                  style={{
                    marginBottom: "0.5rem",
                    padding: "0.5rem",
                    marginRight: "0.5rem",
                  }}
                  type="button"
                  onClick={() =>
                    handleClick(followup, followupIndex, isCompletedSection, "delete")
                  }
                >
                  <Title size={6} textColor="white">
                    Complete | Delete
                  </Title>
                </Button>
              </React.Fragment>
            )}

            <Button
              className="review-option-secondary-goal"
              style={{ marginBottom: "0.5rem", padding: "0.5rem" }}
              type="button"
              onClick={() => handleClick(followup, followupIndex, isCompletedSection)}
            >
              <Title size={6} textColor="white">
                View
              </Title>
            </Button>
          </div>
        </div>
      </Paper>
    </li>
  );
};

FollowupListItem.propTypes = {
  followup: PropTypes.object.isRequired,
  followupIndex: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  handleOpenFollowupAdd: PropTypes.func.isRequired,
  isCompletedSection: PropTypes.bool,
  isUsersOwnFollowups: PropTypes.bool,
  showManagerReviews: PropTypes.bool,
};

FollowupListItem.defaultProps = {
  isCompletedSection: false,
  isUsersOwnFollowups: false,
  showManagerReviews: false,
};

export default FollowupListItem; 